import React from 'react';
import styled, { keyframes } from 'styled-components';

/*
 * Véu de "aguarde" enquanto a API trabalha (salvar, excluir, exportar...).
 * Bloqueia cliques na hora, contra clique duplo, mas só aparece depois de
 * um instante: em ações rápidas a tela não pisca. Para carregar dados de
 * uma lista ou ficha, prefira o esqueleto (components/Skeleton).
 */

const appear = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Veil = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  cursor: progress;
  opacity: 0;
  animation: ${appear} 0.2s ease-out 0.25s forwards;

  body.dark-mode & {
    background: rgba(0, 0, 0, 0.45);
  }
`;

const Spinner = styled.span`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid rgba(253, 126, 20, 0.2);
  border-top-color: var(--fdr-primary, #fd7e14);
  animation: ${spin} 0.8s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 2s;
  }
`;

function MyLoadingOverlay() {
  return (
    <Veil role="status" aria-label="Carregando">
      <Spinner />
    </Veil>
  );
}

export default MyLoadingOverlay;
